import React from 'react';

import type { SubscriberComment } from '@utils/backend-api/subscriber_directory';
import { stripHtml } from '@utils/formatting';

interface PersonalActivityCardProps {
  item: SubscriberComment;
  onClick: (text: string, id?: number) => void;
}

const PersonalActivityCard = ({ item, onClick }: PersonalActivityCardProps) => {
  const isForumPost = item.type === 'forum_post';
  const displayText = isForumPost ? item.commentableTitle : item.body;
  const leadInText = isForumPost ? `Your forum post: ` : `Your comment on: `;

  return (
    <article className="flex flex-col justify-between gap-24 border-0 border-r border-solid border-grayscale-gray pr-24 last-of-type:border-r-0 last-of-type:pr-0 [&:nth-child(2)]:border-r-0 md:[&:nth-child(2)]:border-r">
      <div className="mt-16 flex flex-col gap-8">
        <span className="text-grayscale-dark-gray font-suisse-neue text-body-sm">
          {leadInText}
          {!isForumPost && (
            <a
              className="font-bold transition-colors duration-150 hover:text-primary-magenta"
              href={item.commentableUrl}
              onClickCapture={() => onClick(item.commentableTitle)}
            >
              {item.commentableTitle}
            </a>
          )}
        </span>
        <a
          className="line-clamp-3 block break-words font-suisse-neue text-body-md font-normal text-black no-underline transition-colors duration-150 hover:text-primary-magenta"
          href={item.commentableUrl}
          onClickCapture={() => onClick(item.commentableTitle)}
        >
          {stripHtml(displayText)}
        </a>
      </div>
      <span className="text-grayscale-dark-gray font-suisse-neue text-body-sm">
        {item.commentCreated}
      </span>
    </article>
  );
};

export default PersonalActivityCard;
